module.exports = __webpack_public_path__ + "static/media/inetcfg_2303.ae60da0f.ico";